// Determine if a string is a number
export function isNumeric(n: string | number) {
  return !isNaN(parseFloat(n as string)) && isFinite(n as number);
}

export function isFunction(object: any): object is Function {
  return !!(object && object.constructor && object.call && object.apply);
}

export function stringToHue(str: string) {
  let hash = 63361;
  let i = str.length;

  while (i) {
    hash = (hash * 31) ^ str.charCodeAt(--i);
  }

  return (hash >>> 0) % 360;
}

export function floatEqual(a: number, b: number) {
  return Math.abs(a - b) < Number.EPSILON;
}

// List of too-common passwords
export const commonPasswords = [
  '!@#$%^&*',
  '000000',
  '111111',
  '1111111',
  '121212',
  '123',
  '123123',
  '123321',
  '1234',
  '12345',
  '123456',
  '1234567',
  '12345678',
  '123456789',
  '1234567890',
  '12345679',
  '123qwe',
  '18atcskd2w',
  '1q2w3e',
  '1q2w3e4r',
  '1q2w3e4r5t',
  '1qaz2wsx',
  '3rjs1la7qe',
  '555555',
  '654321',
  '666666',
  '696969',
  '7777777',
  '987654321',
  'Dragon',
  'Football',
  'Iloveyou',
  'Monkey',
  'Qwertyuiop',
  'aa123456',
  'abc123',
  'access',
  'admin',
  'adobe123[a]',
  'ashley',
  'azerty',
  'bailey',
  'baseball',
  'batman',
  'charlie',
  'donald',
  'dragon',
  'flower',
  'football',
  'freedom',
  'google',
  'hello',
  'hottie',
  'iloveyou',
  'jesus',
  'letmein',
  'login',
  'loveme',
  'master',
  'michael',
  'monkey',
  'mustang',
  'mynoob',
  'ninja',
  'passw0rd',
  'password',
  'password1',
  'photoshop[a]',
  'princess',
  'qazwsx',
  'qwerty',
  'qwerty123',
  'qwertyuiop',
  'shadow',
  'solo',
  'starwars',
  'sunshine',
  'superman',
  'trustno1',
  'welcome',
  'whatever',
  'zaq1zaq1',
  'zxcvbnm'
];

// Needle gauge to diameter in mm
export const convertNeedleGauge = (needleGauge: number) => {
  let needleDiameter = 0;

  switch (Math.floor(needleGauge)) {
    case 12:
      needleDiameter = 2.26;
      break;
    case 13:
      needleDiameter = 1.778;
      break;
    case 14:
      needleDiameter = 1.6;
      break;
    case 15:
      needleDiameter = 1.37;
      break;
    case 16:
      needleDiameter = 1.2;
      break;
    case 17:
      needleDiameter = 1.04;
      break;
    case 18:
      needleDiameter = 0.84;
      break;
    case 19:
      needleDiameter = 0.7;
      break;
    case 20:
      needleDiameter = 0.6;
      break;
    case 21:
      needleDiameter = 0.51;
      break;
    case 22:
      needleDiameter = 0.41;
      break;
    case 23:
      needleDiameter = 0.34;
      break;
    case 24:
      needleDiameter = 0.3;
      break;
    case 25:
      needleDiameter = 0.26;
      break;
    case 26:
      needleDiameter = 0.24;
      break;
    case 27:
      needleDiameter = 0.21;
      break;
    case 28:
      needleDiameter = 0.19;
      break;
    case 30:
      needleDiameter = 0.16;
      break;
    case 32:
      needleDiameter = 0.1;
      break;
    case 34:
      needleDiameter = 0.08;
      break;
    default:
      needleDiameter = 0;
  }

  return needleDiameter;
};
